/* eslint-disable */
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RichText } from 'prismic-reactjs';
import { PRISMIC_BANNER_TYPE } from 'app/constants/app';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import * as S from './styles';

const renderTable = (content, columnNumber) => {
  const tableComponent = [];
  const tableBody = [];
  content.items.map((column, index) => {
    const tableContent = [];
    for (const [name, arr] of Object.entries(column)) {
      index === 0
        ? tableContent.push(<th key={name}>{RichText.render(arr)}</th>)
        : tableContent.push(<td key={name}>{RichText.render(arr)}</td>);
    }

    index === 0
      ? tableComponent.push(
          <thead key={index}>
            <tr>{tableContent}</tr>
          </thead>,
        )
      : tableBody.push(<tr key={index}>{tableContent}</tr>);
  });

  return (
    <S.Table columnNumber={Number(columnNumber)}>
      {[...tableComponent]}
      <tbody>{tableBody}</tbody>
    </S.Table>
  );
};

export const renderSlices = slice => {
  // Text Slice
  if (slice.slice_type === 'text') {
    return (
      <S.ProductTextSection>
        {RichText.render(slice.primary.text)}
      </S.ProductTextSection>
    );

    // Table Slice
  }
  if (slice.slice_type.startsWith('table')) {
    return (
      <S.ProductTableSection>
        <S.TableWrapper>
          {renderTable(slice, slice.slice_type.substring(6, 7))}
        </S.TableWrapper>
        {slice.primary.table_title && (
          <span style={{ textAlign: 'center', fontSize: 12 }}>
            {RichText.render(slice.primary.table_title)}
          </span>
        )}
      </S.ProductTableSection>
    );
  }
  return null;
};

const QuestionSeoStoryBoard = ({ prismicBanner }) => {
  const shouldRenderVideo = get(prismicBanner, 'pre[0].text', false);

  if (isEmpty(prismicBanner)) return null;

  return (
    <S.QuestionSection>
      {shouldRenderVideo && (
        <S.VideoWrapper>
          <iframe
            width="100%"
            height="100%"
            src={prismicBanner.pre[0].text}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </S.VideoWrapper>
      )}
      {RichText.render(prismicBanner.bannerDetails)}
    </S.QuestionSection>
  );
};

const ProductAboutBoard = ({ prismicBanner, productName }) => {
  if (isEmpty(prismicBanner) || isEmpty(prismicBanner.about)) return null;

  const isLongContent = RichText.asText(prismicBanner.about).length > 400;
  const [shouldTruncate, toogleTruncate] = useState(isLongContent);

  return (
    <>
      <S.Title>Summary</S.Title>
      <S.ProductSection
        data-testid="prismic-product-detail"
        shouldTruncate={shouldTruncate}
      >
        {RichText.render(prismicBanner.about)}
        {isLongContent && (
          <S.ProductTruncateButton
            onClick={() => toogleTruncate(!shouldTruncate)}
          >
            {shouldTruncate ? `...see more` : 'see less'}
          </S.ProductTruncateButton>
        )}
      </S.ProductSection>
    </>
  );
};

const ProductSeoStoryBoard = ({ prismicBanner }) => {
  if (isEmpty(prismicBanner)) return null;
  const content = prismicBanner.map(slice => renderSlices(slice));

  return <div style={{ padding: 16, backgroundColor: 'white' }}>{content}</div>;
};

const ProductCategorySeoStoryBoard = ({ prismicBanner }) => {
  if (isEmpty(prismicBanner)) return null;
  const content = prismicBanner.map(slice => renderSlices(slice));

  return <S.ProductCategorySection>{content}</S.ProductCategorySection>;
};

const PrismicBanner = props => {
  const { type, productName } = props;

  const questionPrismicBanner = useSelector(state => state.post.prismicBanner);
  const categoryPrismicBanner = useSelector(
    state => state.product.prismicBanner,
  );
  const productDetailsPrismicBanner = useSelector(
    state => state.review.prismicBanner,
  );

  let component;
  switch (type) {
    case PRISMIC_BANNER_TYPE.QUESTION:
      component = (
        <QuestionSeoStoryBoard prismicBanner={questionPrismicBanner} />
      );
      break;
    case PRISMIC_BANNER_TYPE.PRODUCT:
      component = (
        <ProductCategorySeoStoryBoard
          prismicBanner={categoryPrismicBanner.body}
        />
      );
      break;
    case PRISMIC_BANNER_TYPE.PRODUCT_DETAILS_ABOUT:
      component = (
        <ProductAboutBoard
          prismicBanner={productDetailsPrismicBanner}
          productName={productName}
        />
      );
      break;
    case PRISMIC_BANNER_TYPE.PRODUCT_DETAILS_SEO:
      component = !isEmpty(productDetailsPrismicBanner.seo) ? (
        <ProductSeoStoryBoard prismicBanner={productDetailsPrismicBanner.seo} />
      ) : isEmpty(productDetailsPrismicBanner.description) ? null : (
        <S.ProductCategorySection data-testid="prismic-product-detail">
          {RichText.render(productDetailsPrismicBanner.description)}
        </S.ProductCategorySection>
      );
      break;
  }

  return <>{component}</>;
};

export default PrismicBanner;
